import { useEffect, useState } from "react";
import { Bell, X } from "lucide-react";
import { getPermission, hasBeenPrompted, markPrompted, requestPermission } from "../lib/notifications";
import { toast } from "sonner";

export function NotificationsPrompt() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      const perm = getPermission();
      if (perm === "default" && !hasBeenPrompted()) setVisible(true);
    }, 2500);
    return () => clearTimeout(t);
  }, []);

  if (!visible) return null;

  const dismiss = () => {
    markPrompted();
    setVisible(false);
  };

  const enable = async () => {
    const p = await requestPermission();
    setVisible(false);
    if (p === "granted") {
      toast.success("Notificaciones activadas.");
    } else {
      toast.message("Sin problema — te avisaremos con alertas dentro de la app.");
    }
  };

  return (
    <div
      className="fixed left-4 right-4 md:left-auto md:right-4 md:w-96 top-20 z-50 q-glass rounded-2xl border border-white/10 p-4 q-page-enter"
      data-testid="notifications-prompt"
      role="dialog"
      aria-label="Activar notificaciones"
    >
      <div className="flex items-start gap-3">
        <div
          className="h-10 w-10 rounded-2xl flex items-center justify-center border border-white/10"
          style={{ background: "var(--accent-soft)" }}
        >
          <Bell size={18} className="q-accent-text" />
        </div>
        <div className="flex-1">
          <div className="font-display font-semibold text-slate-100 leading-tight">
            ¿Quieres avisos en el navegador?
          </div>
          <div className="text-xs text-slate-300 mt-1 leading-relaxed">
            Te avisamos cuando llegue un mensaje o vibra mientras tienes otra pestaña abierta. Puedes desactivarlo cuando quieras.
          </div>
          <div className="flex gap-2 mt-3">
            <button
              className="q-btn-primary !py-1.5 !px-3 text-xs"
              onClick={enable}
              data-testid="notifications-enable"
            >
              Activar
            </button>
            <button
              className="q-btn-ghost !py-1.5 !px-3 text-xs"
              onClick={dismiss}
              data-testid="notifications-later"
            >
              Ahora no
            </button>
          </div>
        </div>
        <button
          onClick={dismiss}
          className="text-slate-400 hover:text-slate-200"
          aria-label="Cerrar"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
